<template>
  <v-container fluid v-if="infocard.showing" class="mb-10">
    <v-card class="mx-auto box" elevation="1" outlined min-height="200">
      <v-tooltip color="rgb(17, 65, 206)" right>
        <template v-slot:activator="{ on }">
          <v-btn
            absolute
            top
            v-on="on"
            left
            fab
            small
            color="transparent"
            class="mt-9 ml-1 elevation-0"
            @click="out()"
          >
            <v-icon size="33">mdi-chevron-left</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("users.infos.back") }}</span>
      </v-tooltip>
      <v-row align="center" justify="center" class="text-center">
        <v-col cols="auto">
          <v-badge
            bordered
            overlap
            bottom
            :color="
              $store.state.online_users.includes(infos.guid.toString())
                ? 'green'
                : 'red'
            "
            offset-x="10"
            offset-y="10"
            class="bdg"
          >
            <v-avatar size="40">
              <v-avatar size="40" color="grey darken-1" v-if="infos.firstname">
                <span class="white--text headline">{{
                  infos.firstname[0].toUpperCase()
                }}</span>
              </v-avatar>
              <v-icon size="48" color="gray darken-1" v-else
                >mdi-account-circle</v-icon
              >
            </v-avatar>
          </v-badge>
        </v-col>
        <v-col cols="auto" class="pl-0">
          <span class="title">
            {{
              infos.firstname
                ? infos.firstname[0].toUpperCase() + infos.firstname.slice(1)
                : `#${infos.id}`
            }}
          </span>
        </v-col>
        <v-menu offset-y left>
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip color="rgb(17, 65, 206)" left>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  absolute
                  class="mt-3 mr-1 elevation-0"
                  right
                  large
                  color="black"
                  dark
                  icon
                  v-bind="attrs"
                  v-on="{ ...tooltip, ...menu }"
                >
                  <v-icon>mdi-file-download</v-icon>
                </v-btn>
              </template>
              <span> {{ $t("users.infos.csv_download.btn") }} </span>
            </v-tooltip>
          </template>
          <v-list color="#fafafa" class="pb-0" dense subheader>
            <download-csv
              class="btn btn-default"
              :data="csv_data"
              name="export_user_infos.csv"
            >
              <v-list-item link>
                <v-list-item-title>
                  {{ $t("users.infos.csv_download.export_info") }}
                </v-list-item-title>
              </v-list-item>
            </download-csv>
            <download-csv
              class="btn btn-default"
              :data="csv_data_all"
              name="export_all_user.csv"
            >
              <v-list-item link>
                <v-list-item-title>
                  {{ $t("users.infos.csv_download.export_all") }}
                </v-list-item-title>
              </v-list-item>
            </download-csv>
          </v-list>
        </v-menu>
      </v-row>

      <Infos :infos="infos" />
    </v-card>
  </v-container>
</template>

<script>
import Infos from "../user-info/Infos-display";

export default {
  name: "infos_display",
  data() {
    return {
      csv_data: [],
      csv_data_all: [],
    };
  },
  components: {
    Infos,
  },
  created() {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        this.out();
      }
    });
  },
  destroyed() {
    this.$store.dispatch("setInfocard", {
      showing: false,
    });
  },
  computed: {
    infocard() {
      return this.$store.state.infocard;
    },
    infos: {
      get: function () {
        const info = this.$store.state.user.infos.user;
        this.set_csv(info);
        return info;
      },
    },
  },
  methods: {
    set_csv(info) {
      this.csv_data = [
        {
          Id: info.id,
          Username: info.username || "-",
          Firstname: info.firstname || "-",
          Lastname: info.lastname || "-",
          Gender: info.gender || "-",
          Email: info.email || "-",
          Language: info.language || "-",
          Address: info.address || "-",
          Created_at: info.created_at || "-",
        },
      ];
      this.csv_data_all = [
        {
          Id: info.id,
          Username: info.username || "-",
          Firstname: info.firstname || "-",
          Lastname: info.lastname || "-",
          Gender: info.gender || "-",
          Email: info.email || "-",
          Language: info.language || "-",
          Address: info.address || "-",
          Created_at: info.created_at || "-",
          updated_at: info.updated_at || "-",
          slack_channel_id: info.slack_channel_id || "-",
          bookmarked_products: info.products_bookmarked
            ? info.products_bookmarked.length
            : "0",
          disliked_products: info.products_disliked
            ? info.products_disliked.length
            : "0",
          ignored_products: info.products_ignored
            ? info.products_ignored.length
            : "0",
          liked_products: info.products_liked
            ? info.products_liked.length
            : "0",
          seen_products: info.products_seen ? info.products_seen.length : "0",
        },
      ];
    },
    out() {
      this.$store.state.user.infos.prod_seen = [];
      this.$store.state.user.infos.prod_liked = [];
      this.$store.state.user.infos.prod_ignored = [];
      this.$store.state.user.infos.prod_bookmarked = [];
      this.$store.state.user.infos.prod_disliked = [];
      this.$store.state.infocard.showing = false;
      if (this.$store.state.infocard.from === "message")
        this.$store.state.show.dash = true;
      this.$store.state.prod_to_sent.ids = [];
      this.$store.state.prod_to_sent.item = [];
    },
  },
};
</script>

<style>
.box {
  width: 100%;

  background: #fafafa;
}
.bdg .v-badge__badge {
  height: 14px;
  min-width: 14px;
}
</style>
